<template>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">Blog Post</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item">
                                <router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">
                                Blog Post
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary" @click="$router.push('/add-blog-post')">
                            <i class="bx bxs-plus-square"></i>Add New Blog Post
                        </button>
                    </div>
                </div>
            </div>
            <h6 class="mb-0 text-uppercase">Blog Post List</h6>
            <hr />
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table id="example" class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Post Title</th>
                                    <th>Category Name</th>
                                    <th>Photo</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in blogList" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ row.title.length > 50 ? row.title.slice(0, 50) + '...' : row.title }}</td>
                                    <td>{{ row.categoryName }}</td>
                                    <td v-if="row.photo != null">
                                        <img :src="row.photo" height="100" width="120"/>
                                    </td>
                                    <td v-else>
                                        <img src="/core/assets/images/blog.png" width="50" height="80" />
                                    </td>
                                    <td>{{ $filters.formatDateTime(row['createdAt']) }}</td>
                                    <td>
                                        <div class="d-flex order-actions">
                                            <router-link :to="{ name: 'EditBlogPost', params: { id: row.id } }" class="edit-button"><i class="bx bxs-edit text-white"></i></router-link>
                                            <a href="javascript:void(0);" v-on:click="deletePost(row.id)" class="ms-3 delete-button"><i class="bx bxs-trash text-white"></i></a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Sl</th>
                                    <th>Post Title</th>
                                    <th>Category Name</th>
                                    <th>Photo</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import "../../../../public/core/assets/plugins/datatable/css/dataTables.bootstrap5.min.css";

.edit-button {
    background-color: #17a00e;
}

.delete-button {
    background-color: #f41127;
}</style>

<script src="../js/blog-post.js"></script>